import { EyeOutlined } from '@ant-design/icons';
import Popover from 'antd/lib/popover';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import React, { useMemo, useState } from 'react';
import { defaultDateTimeFormat } from '../../domain/common/dateFormatters';
import { EmailParseStatus, IEmailUtilityAutomationHistory } from '../../domain/email-utility-automation/interface';
import { EmailUtilityAutomationHistoryContentModal } from './EmailUtilityAutomationHistoryContentModal';
import { getEmailUtilityAutomationHistoryStatusColor } from './helpers';

const HINT = (
    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        <EyeOutlined /> Click to view email content
    </Typography.Text>
);

export const EmailUtilityAutomationShortHistoryItem = ({ historyItem }: { historyItem: IEmailUtilityAutomationHistory }) => {
    const color = getEmailUtilityAutomationHistoryStatusColor(historyItem.status);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const content = useMemo(() => {
        const formattedDateTime = defaultDateTimeFormat(historyItem.datetime);

        const message = (() => {
            switch (historyItem.status) {
                case EmailParseStatus.IN_PROGRESS:
                    return <Typography.Text>Received email. Parsing in progress at {formattedDateTime}</Typography.Text>;
                case EmailParseStatus.SUCCESS:
                    return (
                        <Typography.Text>
                            Successfully created event to {historyItem.created_events_count} sites at {formattedDateTime}
                        </Typography.Text>
                    );
                case EmailParseStatus.PARSER_DISABLED:
                    return <Typography.Text>Email received at {formattedDateTime} but parser was disabled</Typography.Text>;
                case EmailParseStatus.IGNORED:
                    return <Typography.Text>Email parsing was skipped at {formattedDateTime}</Typography.Text>;
                case EmailParseStatus.FAILED:
                    return (
                        <>
                            <Typography.Text>Failed to parse at {formattedDateTime}</Typography.Text>
                            <Typography.Text>Error: {historyItem.error_message}</Typography.Text>
                        </>
                    );
                default:
                    return null;
            }
        })();

        if (!message) return null;

        return (
            <Space direction="vertical">
                {message}
                {HINT}
            </Space>
        );
    }, [historyItem]);

    return (
        <>
            <Popover content={content}>
                <Square color={color} onClick={() => setIsPreviewOpen(true)} />
                &nbsp;
            </Popover>
            {isPreviewOpen && (
                <EmailUtilityAutomationHistoryContentModal messageId={historyItem.message_id} onClose={() => setIsPreviewOpen(false)} />
            )}
        </>
    );
};

const Square = ({ color, onClick }: { color: string; onClick: () => void }) => {
    return (
        <span
            onClick={onClick}
            style={{
                display: 'inline-block',
                width: 15,
                height: 15,
                backgroundColor: color,
                borderRadius: 3,
                cursor: 'pointer',
            }}
        />
    );
};
